import { ContentChildren, Component, EventEmitter, Input, QueryList, Output } from '@angular/core';

import { PuiButtonComponent } from '../button/index';

@Component({
  selector: 'pui-form-command',
  templateUrl: 'form-command.component.html'
})
export class PuiFormCommandComponent {
  @Input() disabled: boolean;
  @ContentChildren(PuiButtonComponent) buttons: QueryList<PuiButtonComponent>;
  @Output() actionSubmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() actionCancel: EventEmitter<any> = new EventEmitter<any>();

  onSubmit() {
    this.actionSubmit.emit();
  }

  onCancel() {
    this.actionCancel.emit();
  }
}
